/* eslint-disable no-console */

/**
 * @fileOverview A function that loads fonts with the help of FontFaceObserver.
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires NPM:fontFaceObserver
 * @requires Polyfill:Element.prototype.classList
 */

import FontFaceObserver from 'fontfaceobserver-es/dist/fontfaceobserver.esm';

/**
 * @function loadFonts
 * @description Use FontFaceObserver to load a font and then execute the
 *   callback function, which defaults to adding a 'fonts-loaded' class to the
 *   root element of the document.
 * @arg {String} font - The font name.
 * @arg {Function} [callBack] - An optional callback function reference to
 *   override the default one.
 */
export default function loadFonts( font = 'Ubuntu', callBack ) {

  const cb =
    typeof callBack === 'function' ?
      cb :
      () => {
        document.documentElement.classList.add( 'fonts-loaded' )
      };

  new FontFaceObserver( font )
    .load()
    .then( cb )
    .catch( error => {
      console.error( error )
    });
}
